<div id="HeaderNavigation">
    <div id="market-menu" ></div>
    <div id="nav-burger-content" ></div>
</div>